import { createApi, retry } from "@reduxjs/toolkit/query/react"
import { axiosBaseQuery } from "@/api/service"

const baseQuery = axiosBaseQuery()

const baseQueryWithRetry = retry(baseQuery, { maxRetries: 0 })

export enum TAGS {
  AUTH = "AUTH",
  USER = "USER",
  PLAYER = "PLAYER",
  DECK = "DECK",
  MAINTENANCE = "MAINTENANCE",
  EFFECTS = "EFFECTS",
  BALANCE = "BALANCE",
  SERVER_TIME = "SERVER_TIME",
  MATCH = "MATCH",
  GAMEPLAY = "GAMEPLAY",
  INFO_MODAL = "INFO_MODAL",
  STORE = "STORE",
  STORE_PAYMENTS = "STORE_PAYMENTS",
  CARD_BACKS = "CARD_BACKS",
  PERSONAL_DECK = "PERSONAL_DECK",
  FRIEND_LOBBY = "FRIEND_LOBBY",
  WITHDRAWAL = "WITHDRAWAL",
  DEPOSIT = "DEPOSIT",
  REFERRAL = "REFERRAL",
  QUESTS = "QUESTS"
}

export const api = createApi({
  reducerPath: "splitApi",
  baseQuery: baseQueryWithRetry,
  refetchOnFocus: false,
  endpoints: () => ({})
})
